import { cancel } from "common/promises";
import { Sheets } from "common/sheets";
export class Mum {
    constructor(pixiContext, sheets) {
        this.pixiContext = pixiContext;
        this.sprite = Sheets.sprite(sheets, fileName);
        // Change the center of the rotation
        this.sprite.position.set(-4, 158);
        this.sprite.pivot.set(-4, 158);
        console.log("mum", this.sprite);
    }
    animate() {
        return cancel.root(async (canceler) => {
            const start = -30;
            const destination = 10;
            while (true) {
                canceler.check();
                await this.pixiContext.animate({
                    start,
                    destination,
                    durationMS: 1000,
                    setter: (value) => {
                        canceler.check();
                        this.sprite.angle = value;
                    },
                });
                await this.pixiContext.animate({
                    start: destination,
                    destination: start,
                    durationMS: 1000,
                    setter: (value) => {
                        canceler.check();
                        this.sprite.angle = value;
                    },
                });
            }
        });
    }
}
export const fileName = "국화_optimized.png";
//# sourceMappingURL=mum.js.map